import { render, staticRenderFns } from "./Somatometry.vue?vue&type=template&id=615bb43a&"
import script from "./Somatometry.vue?vue&type=script&lang=js&"
export * from "./Somatometry.vue?vue&type=script&lang=js&"
import style0 from "./Somatometry.vue?vue&type=style&index=0&id=615bb43a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports